import { inject, InjectionToken } from '@angular/core';
import { APP_ENV } from '@easihub/ngx';

export const ENVIRONMENT = new InjectionToken('ENVIRONMENT', {
  providedIn: 'root',
  factory: () => {
    const env = inject(APP_ENV);

    switch (env) {
      case 'local': return {
        api: 'https://localhost:4001',
        origin: 'https://localhost:4003',
        oauth: {
          issuer: 'https://localhost:4002',
          clientId: 'QrFAGmXFHMUppoWHmZtljjJoPCMkCren',
        },
      };
      case 'staging': return {
        api: 'https://api.development.branches.easihub.com',
        origin: 'https://development.branches.easihub.com',
        oauth: {
          issuer: 'https://accounts.development.branches.easihub.com',
          clientId: 'QrFAGmXFHMUppoWHmZtljjJoPCMkCren',
        },
      };
      case 'production': return {
        api: 'https://api.easihub.com',
        origin: 'https://easihub.com',
        oauth: {
          issuer: 'https://accounts.easihub.com',
          clientId: 'QrFAGmXFHMUppoWHmZtljjJoPCMkCren',
        },
      };
    }
  }
});

